import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { Dropdown, PrimaryButton, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import PotentialWinnersTable from '../Components/PotentialWinnersTable';
import ActualWinnersTable from '../Components/ActualWinnersTable';
import { sortBy } from 'lodash';
import IncompleteMonthWarning from '../Components/IncompleteMonthWarning';
import VoidedWinnersTable from '../Components/VoidedWinnersTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const WinnerSelectionPage = () => {
    const { year: _yearFromParams, month: _monthFromParams } = useParams();
    const yearFromParams = Number(_yearFromParams);
    const monthFromParams = Number(_monthFromParams);

    //// Actual Winners \\\\
    const [{ data: _actualWinners, loading: actualWinnersLoading }, actualWinnersRefetch] = useAxios({
        url: 'rewards/sprouts/admin/actual-winners',
        method: 'GET',
        params: {
            Year: yearFromParams,
            Month: monthFromParams,
        },
    });
    const actualWinners = _actualWinners?.users ? sortBy(_actualWinners?.users, (x) => x.amountWon * -1) : null;

    //// Get Potential Winners \\\\
    const [{ data: _potentialWinners, loading: potentialWinnersLoading }, potentialWinnersRefetch] = useAxios({
        url: 'rewards/sprouts/admin/potential-winners',
        method: 'GET',
        params: {
            Year: yearFromParams,
            Month: monthFromParams,
        },
    });
    const potentialWinners = _potentialWinners?.users ? sortBy(_potentialWinners?.users, (x) => x.entryRef) : null;
    
    //// Mark Potential Winner \\\\
       const [{}, postMarkPotentialWinner] = useAxios(
        {
            url: 'rewards/sprouts/admin/mark-potential-winners',
            method: 'POST',
        },
        {
            manual: true,
        }
    );

    const drawUsers = () => {
        postMarkPotentialWinner({
            data: {
                UserCount: 20,
                Year: yearFromParams,
                Month: monthFromParams,
            },
        }).then(() => potentialWinnersRefetch());
    };

    //// Void Potential Winner \\\\
    const [{}, postVoidPotentialWinner] = useAxios(
        {
            url: 'rewards/sprouts/admin/void-potential-winner',
            method: 'POST',
        },
        { manual: true }
    );
    const voidPotentialWinner = (winner) => {
        return postVoidPotentialWinner({
            data: {
                UserId: winner.userId,
                Year: yearFromParams,
                Month: monthFromParams,
            },
        }).then(() => {
            potentialWinnersRefetch();
        });
    };

    //// Mark Winner \\\\
    const [{}, postMarkWinner] = useAxios(
        {
            url: 'rewards/sprouts/admin/mark-winner',
            method: 'POST',
        },
        {
            manual: true,
        }
    );
    const markWinner = (winner) => {
        postMarkWinner({
            data: {
                UserId: winner.userId,
                Year: yearFromParams,
                Month: monthFromParams,
                EntryRef: winner.entryRef,
            },
        }).then(() => actualWinnersRefetch());
    };

    //// Void Winner \\\\
    const [{}, postVoidWinner] = useAxios(
        {
            url: 'rewards/sprouts/admin/void-winner',
            method: 'POST',
        },
        { manual: true }
    );
    const voidWinner = (loserId) => {
        return postVoidWinner({
            data: {
                UserId: loserId,
                Year: yearFromParams,
                Month: monthFromParams,
            },
        }).then(() => {
            actualWinnersRefetch();
            voidedWinnersRefetch();
        });
    };
    
    const [{ data: _voidedWinners, loading: voidedWinnersLoading }, voidedWinnersRefetch] = useAxios({
        url: 'rewards/sprouts/admin/voided-winners',
        method: 'GET',
        params: {
            Year: yearFromParams,
            Month: monthFromParams,
        },
    });
    const voidedWinners = _voidedWinners?.users ? sortBy(_voidedWinners?.users, (x) => x.userId) : null;

    //// Save Quote \\\\
    const [{ loading: postUserQuoteLoading }, postUserQuote] = useAxios(
        {
            url: 'rewards/sprouts/admin/update-quote',
            method: 'POST',
        },
        {
            manual: true,
        }
    );

    const saveQuote = (userId, quote) => {
        const promise = postUserQuote({ data: { UserId: userId, Quote: quote } });
        promise.then(() => actualWinnersRefetch());
        return promise;
    };

    return (
        <div>
            <IncompleteMonthWarning year={yearFromParams} month={monthFromParams} />

            <h2>Potential Winners</h2>
            {potentialWinnersLoading && <Spinner label="loading potential winners..." />}
            {potentialWinners?.length === 0 && !potentialWinnersLoading && (
                <>
                    <PrimaryButton
                        text="Draw"
                        onClick={drawUsers}
                        allowDisabledFocus
                        checked={false}
                    />
                </>
            )}
            {potentialWinners?.length > 0 && (
                <PotentialWinnersTable
                    potentialWinners={potentialWinners}
                    voidPotentialWinner={voidPotentialWinner}
                    markAsWinner={markWinner}
                    atCapacity={actualWinners?.length >= 5}
                />
            )}

            <h2>Selected Winners</h2>
            {actualWinnersLoading && <Spinner label="loading actual winners..." />}
            {actualWinners && (
                <ActualWinnersTable
                    actualWinners={actualWinners}
                    saveQuote={saveQuote}
                    postUserQuoteLoading={postUserQuoteLoading}
                    voidWinner={voidWinner}
                />
            )}
            {voidedWinners?.length > 0 && (
                <>
                    <h2>Voided Winners</h2>
                    <VoidedWinnersTable voidedWinners={voidedWinners} />
                </>
            )}
            <FeatureSummary
                label="About Sweepstakes Winner Selection"
                summary="Manage the sweepstakes winner selection process for a given month. Draw potential winners from eligible entries, review and select actual winners, void entries if needed, and record winner quotes. Up to 5 winners can be selected per month."
            />
        </div>
    );
};

export default WinnerSelectionPage;
